/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type ContentStackSitewideAlertBanner } from '@/features/contentstack/interface';
import React from 'react';
import styles from 'src/features/header/components/TopHeader/contentstack/CMSSiteWideAlertBanner/styles.module.scss';
import { useLabels } from '@/hooks/useLabels';
import AlertIcon from '@/public/images/alert.svg';
import { View, Text } from '@az/starc-ui';

type Props = {
  content: ContentStackSitewideAlertBanner;
};

const defaultAlertLabel = { defaultLabelAlert: 'label_default_alert' };
const CMSSitewideAlertBanner = ({ content }: Props) => {
  const { defaultLabelAlert } = useLabels(defaultAlertLabel);
  return (
    <View
      align="center"
      direction="row"
      data-testid="sitewide-alert-banner"
      className={styles.sitewideAlertBanner}
    >
      <View className={styles.sitewideAlertBannerIconWrapper}>
        <AlertIcon
          className={styles.sitewideAlertBannerIcon}
          width={25}
          height={25}
          aria-hidden="true"
          role="img"
          data-testid="alert-icon"
        />
      </View>
      <Text weight="medium" className={styles.sitewideAlertBannerText}>
        {content.alert_text || defaultLabelAlert}
      </Text>
    </View>
  );
};

export default CMSSitewideAlertBanner;
